import React from 'react';
import styled from 'styled-components';
import { ButtonText } from 'components/atoms/Text';

const ButtonContainer = styled.button`
    background: ${(props) => (props.active ? props.activeColor : props.inactiveColor)};
    border: none;
    border-radius: 6px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-left: 14px;
    padding-right: 14px;
    height: 36px;
    width: ${(props) => (props.width ? props.width : 'fit-content')};

    &:hover {
        cursor: ${(props) => (props.active ? 'pointer' : 'default')};
        ${(props) => (props.active ? 'background-color: #4136c0' : '')};
    }

    &:disabled {
        background-color: #bdbdbd;
        cursor: default;
    }
`;

const PrimaryButton = ({
    text,
    active = false,
    disabled = false,
    width = null,
    activeColor = '#6347ff',
    inactiveColor = '#BDBDBD',
    ...props
}) => {
    return (
        <ButtonContainer
            active={active}
            disabled={disabled}
            width={width}
            activeColor={activeColor}
            inactiveColor={inactiveColor}
            {...props}
        >
            <ButtonText style={{ color: 'white', fontSize: 14 }}>{text}</ButtonText>
        </ButtonContainer>
    );
};

export default PrimaryButton;
